import React from 'react';
import { MapPinIcon, PhoneIcon, MailIcon, SendIcon, InstagramIcon, TwitterIcon, LinkedinIcon, YoutubeIcon } from 'lucide-react';
export const Contact = () => {
  return <section id="contact" className="py-20 bg-gray-800" data-id="element-52">
      <div className="container mx-auto px-4" data-id="element-53">
        <h2 className="text-4xl font-bold mb-2 text-center" data-id="element-54">Contact Me</h2>
        <p className="text-gray-400 text-center mb-12" data-id="element-55">
          Let's discuss your project
        </p>
        <div className="grid grid-cols-1 lg:grid-cols-2 gap-12" data-id="element-56">
          {/* Contact Form */}
          <div className="bg-gray-900/50 p-8 rounded-lg" data-id="element-57">
            <h3 className="text-2xl font-bold mb-6" data-id="element-58">Send a Message</h3>
            <form data-id="element-59">
              <div className="grid grid-cols-1 md:grid-cols-2 gap-6 mb-6" data-id="element-60">
                <div data-id="element-61">
                  <label htmlFor="name" className="block text-sm font-medium text-gray-400 mb-1" data-id="element-62">
                    Name
                  </label>
                  <input type="text" id="name" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Your name" data-id="element-63" />
                </div>
                <div data-id="element-64">
                  <label htmlFor="email" className="block text-sm font-medium text-gray-400 mb-1" data-id="element-65">
                    Email
                  </label>
                  <input type="email" id="email" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="your.email@example.com" data-id="element-66" />
                </div>
              </div>
              <div className="mb-6" data-id="element-67">
                <label htmlFor="subject" className="block text-sm font-medium text-gray-400 mb-1" data-id="element-68">
                  Subject
                </label>
                <input type="text" id="subject" className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="What is this regarding?" data-id="element-69" />
              </div>
              <div className="mb-6" data-id="element-70">
                <label htmlFor="message" className="block text-sm font-medium text-gray-400 mb-1" data-id="element-71">
                  Message
                </label>
                <textarea id="message" rows={5} className="w-full bg-gray-800 border border-gray-700 rounded-lg px-4 py-2 text-white focus:outline-none focus:ring-2 focus:ring-indigo-500" placeholder="Tell me about your project..." data-id="element-72"></textarea>
              </div>
              <button type="submit" className="bg-indigo-600 hover:bg-indigo-700 text-white py-3 px-6 rounded-lg transition-colors flex items-center" data-id="element-73">
                Send Message
                <SendIcon size={18} className="ml-2" data-id="element-74" />
              </button>
            </form>
          </div>
          {/* Contact Info */}
          <div data-id="element-75">
            <h3 className="text-2xl font-bold mb-6" data-id="element-76">Contact Information</h3>
            <div className="space-y-6 mb-12" data-id="element-77">
              <div className="flex items-start" data-id="element-78">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4" data-id="element-79">
                  <MapPinIcon size={24} className="text-indigo-400" data-id="element-80" />
                </div>
                <div data-id="element-81">
                  <h4 className="font-semibold text-lg" data-id="element-82">Location</h4>
                  <p className="text-gray-400" data-id="element-83">Copenhagen, Denmark</p>
                </div>
              </div>
              <div className="flex items-start" data-id="element-84">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4" data-id="element-85">
                  <MailIcon size={24} className="text-indigo-400" data-id="element-86" />
                </div>
                <div data-id="element-87">
                  <h4 className="font-semibold text-lg" data-id="element-88">Email</h4>
                  <a href="mailto:sparrebs@gmail.com" className="text-gray-400 hover:text-indigo-400 transition-colors" data-id="element-89">
                    sparrebs@gmail.com
                  </a>
                </div>
              </div>
              <div className="flex items-start" data-id="element-90">
                <div className="bg-indigo-600/20 p-3 rounded-lg mr-4" data-id="element-91">
                  <PhoneIcon size={24} className="text-indigo-400" data-id="element-92" />
                </div>
                <div data-id="element-93">
                  <h4 className="font-semibold text-lg" data-id="element-94">Phone</h4>
                  <p className="text-gray-400" data-id="element-95">Available upon request (+45)</p>
                </div>
              </div>
            </div>
            {/* Social Media */}
            <div data-id="element-96">
              <h3 className="text-xl font-bold mb-4" data-id="element-97">Follow Me</h3>
              <div className="flex space-x-4" data-id="element-98">
                {[{
                icon: <InstagramIcon size={20} data-id="element-99" />,
                href: '#',
                label: 'Instagram'
              }, {
                icon: <TwitterIcon size={20} data-id="element-100" />,
                href: '#',
                label: 'Twitter'
              }, {
                icon: <LinkedinIcon size={20} data-id="element-101" />,
                href: 'https://linkedin.com/in/søren-bro-sparre-6a197295',
                label: 'LinkedIn'
              }, {
                icon: <YoutubeIcon size={20} data-id="element-102" />,
                href: '#',
                label: 'YouTube'
              }].map((social, index) => <a key={index} href={social.href} aria-label={social.label} className="bg-gray-800 hover:bg-indigo-600 w-10 h-10 rounded-full flex items-center justify-center transition-colors" data-id="element-103">
                    {social.icon}
                  </a>)}
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>;
};